import { Column, ColumnConfig } from '@ant-design/charts';
import { useLazyQuery } from '@apollo/client';
import { GET_DASHBOARD_IDEA_DELIVERY_DURATION } from '@frontend/data-access';
import { Card } from 'antd';
import { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface DeliveryDurationProps {
  channelId?: string;
  challengeId?: string;
  innovationSpaceId?: string;
}

export function DeliveryDuration({
  channelId,
  challengeId,
  innovationSpaceId,
}: DeliveryDurationProps) {
  const { t } = useTranslation('common');

  const [getData, { data, loading }] = useLazyQuery<{
    dashboardIdeaDeliveryDuration: {
      name: string;
      count: number;
    }[];
  }>(GET_DASHBOARD_IDEA_DELIVERY_DURATION);

  const config: ColumnConfig = {
    data: data?.dashboardIdeaDeliveryDuration ?? [],
    loading: loading,
    xField: 'name',
    yField: 'count',
    legend: false,
    color: '#529FF0',
    paddingTop: 20,
    label: {
      text: 'count',
      position: 'top',
      textAlign: 'center',
      dy: -15,
      style: {
        fontFamily: 'Lufga',
      },
    },
  };

  useEffect(() => {
    getData({
      variables: {
        channelId,
        challengeId,
        spaceId: innovationSpaceId,
      },
    });
  }, [challengeId, channelId, getData, innovationSpaceId]);

  return (
    <Card style={{ borderRadius: 20 }} className="space-y-4">
      <div className="text-sm text-gray-900 font-medium">
        {t('delivery_duration')}
      </div>
      <Column {...config} />
    </Card>
  );
}

export default DeliveryDuration;
